var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.8999V8.8999C21 6.13848 18.7614 3.8999 16 3.8999C13.2386 3.8999 11 6.13848 11 8.8999V14.8999M26.1414 12.2429L27.8256 28.2429C27.9188 29.1285 27.2244 29.8999 26.3338 29.8999H5.66618C4.77562 29.8999 4.08119 29.1285 4.17442 28.2429L5.85863 12.2429C5.93899 11.4795 6.58275 10.8999 7.35039 10.8999H24.6496C25.4172 10.8999 26.061 11.4795 26.1414 12.2429ZM11.5 14.8999C11.5 15.176 11.2761 15.3999 11 15.3999C10.7239 15.3999 10.5 15.176 10.5 14.8999C10.5 14.6238 10.7239 14.3999 11 14.3999C11.2761 14.3999 11.5 14.6238 11.5 14.8999ZM21.5 14.8999C21.5 15.176 21.2761 15.3999 21 15.3999C20.7239 15.3999 20.5 15.176 20.5 14.8999C20.5 14.6238 20.7239 14.3999 21 14.3999C21.2761 14.3999 21.5 14.6238 21.5 14.8999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.33f3a740ff2109bdc74ec70dd45cbf88.svg";
export { ForwardRef as ReactComponent };